// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__fgmHD","buttons":"RemoveExpirationActionButtons_buttons__2BoqP"};